import * as React from 'react';

import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';

import { IGetPageShopsRepo, GetPageShopsRepoType } from '../../repos';

export const useShopsTableContext = () => {
  const getShopsRepo = useService<IGetPageShopsRepo>(GetPageShopsRepoType);

  const onFetch = React.useCallback(
    async (params: TableFetchParams) => {
      const result = await getShopsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getShopsRepo],
  );

  return { onFetch };
};
